/* eslint-disable react/no-array-index-key */
/* eslint-disable react/prop-types */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';
import {
  MdOutlineAccountBalanceWallet,
  MdOutlineCreditCard,
  MdOutlineQrCode2,
} from 'react-icons/md';
import { IoIosCard } from 'react-icons/io';
import { PiBankBold } from 'react-icons/pi';
import {
  getUserAgentId,
  getValueFromAppConfig,
} from '../../shared/helper-utils/localStorage';
import {
  getFlightHoldQueuesApi,
  getFlightPendingHoldQueuesApi,
  performticketing,
  releaseTicketApi,
  getPaymentGateway,
} from '../../api/flightApi';
import AppLoading from '../../shared/components/app-loading/AppLoading';
import { TicketsIcon } from '../../shared/components/app-icons/AppIcons';
import AppLink from '../../shared/components/app-link/AppLink';
import {
  DATE_MONTH_YEAR_FORMAT,
  NAVIGATION_ROUTES,
} from '../../shared/constants/Constants';
import AppTextInput from '../../shared/components/app-text-input/AppTextInput';
import { debounce } from '../../api/apiUtils';
import AppModal from '../../shared/components/app-modal/AppModal';
import AppButton from '../../shared/components/app-button/AppButton';
import AppAlert from '../../shared/components/app-alert/AppAlert';
import { formatDate, getNewDate } from '../../shared/helper-utils/appUtils';
import AppIconButton from '../../shared/components/app-icon-button/AppIconButton';
import AppRadioInput from '../../shared/components/app-radio-input/AppRadioInput';
import { useAppContext } from '../../saas/AppConfigWrapper';

const iconStyle = { fontSize: 22, marginRight: 8, color: '#374471' };
const isUpiandNetbankingRequired =
  getValueFromAppConfig('REMOVE_UPI_AND_NETBANKING') === 'true';
const paymentModeOptions = [
  { mode: 'creditcard', label: 'Credit Card', Icon: MdOutlineCreditCard },
  { mode: 'debitcard', label: 'Debit Card', Icon: IoIosCard },
  ...(!isUpiandNetbankingRequired
    ? [
        { mode: 'netbanking', label: 'Net Banking', Icon: PiBankBold },
        { mode: 'upi', label: 'UPI', Icon: MdOutlineQrCode2 },
      ]
    : []),
];

function FlightHoldQueues({ isPending = false }) {
  const { appConfig } = useAppContext();
  const showOtherPaymentMethods =
    String(appConfig?.showOtherPaymentMethodsInFlightHoldQueues ?? '')
      .trim()
      .toLowerCase() === 'true';
  const navigate = useNavigate();
  const agentId = getUserAgentId();
  const [searchText, setSearchText] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [holdQueuesList, setHoldQueuesList] = useState([]);
  const allHoldQueuesListRef = useRef([]);
  const [showConfirmPopup, setShowConfirmPopup] = useState(false);
  const selectedTransactionRef = useRef(undefined);
  const [alert, setAlert] = useState(undefined);
  const [showReleasePopup, setShowReleasePopup] = useState(false);
  const [selectedPaymentMode, setSelectedPaymentMode] = useState('wallet');
  const [availablePaymentGateways, setAvailablePaymentGateways] = useState([]);
  const [selectedPaymentGateway, setSelectedPaymentGateway] = useState('');
  const [isLoadingPaymentGateways, setIsLoadingPaymentGateways] =
    useState(false);
  const [paymentGatewayError, setPaymentGatewayError] = useState('');

  const getFlightHoldQueues = async () => {
    setIsLoading(true);
    const response = isPending
      ? await getFlightPendingHoldQueuesApi(agentId)
      : await getFlightHoldQueuesApi(agentId);
    if (response?.Root?.Status === 'OK') {
      let list = response.Root.Result;
      if (list !== '') {
        list = Array.isArray(list.FlightRecord)
          ? list.FlightRecord
          : [list.FlightRecord];
        setHoldQueuesList(list);
        allHoldQueuesListRef.current = list;
      } else {
        setHoldQueuesList([]);
      }
    } else {
      setHoldQueuesList([]);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    getFlightHoldQueues();
  }, [isPending]);
  const getFlightTicketRoute = (txid) => {
    let route = NAVIGATION_ROUTES.FLIGHT.FLIGHT_TICKET_PAGE;
    route = route.replace(':transactionId', txid);
    return route;
  };

  const setSearchResults = debounce((val) => {
    let data = [...allHoldQueuesListRef.current];
    if (val !== '') {
      data = data.filter((o) =>
        Object.keys(o).some(
          (k) =>
            o[k] !== null &&
            o[k] !== undefined &&
            o[k].toString().toLowerCase().includes(val.toLowerCase()),
        ),
      );
    }
    setHoldQueuesList(data);
  }, 500);

  const handleSearch = (event) => {
    const { value } = event.target;
    setSearchText(value);
    setSearchResults(value);
  };

  function FlightDetail({ info, value }) {
    return (
      <div className="d-flex flex-column">
        <span className="my-bookings-page__booking_header_info">{info}</span>
        <span className="my-bookings-page__booking_header_value">{value}</span>
      </div>
    );
  }

  const handleClosePerformBookingModal = () => {
    setShowConfirmPopup(false);
    selectedTransactionRef.current = undefined;
  };
  const handleCloseReleasePopup = () => {
    setShowReleasePopup(false);
    selectedTransactionRef.current = undefined;
  };

  const isOldFlowMode = (mode) =>
    !mode || mode === 'cashcard' || mode === 'wallet';

  const handlePerformTicket = async () => {
    setIsLoading(true);
    const res = showOtherPaymentMethods
      ? await performticketing(
          selectedTransactionRef.current,
          selectedPaymentMode,
          selectedPaymentGateway || '',
        )
      : await performticketing(selectedTransactionRef.current);
    if (res && res.ApiStatus?.Status === 'OK') {
      if (showOtherPaymentMethods && !isOldFlowMode(selectedPaymentMode)) {
        const { PgUrl, Txid } = res.ApiStatus.Result || {};
        if (PgUrl && Txid) {
          window.location.href = `${PgUrl}?txid=${Txid}`;
          return;
        }
        setAlert({
          variant: 'error',
          title: 'Hold Flight',
          description: 'Payment gateway URL was not provided.',
        });
        setIsLoading(false);
        return;
      }
      setAlert({
        variant: 'success',
        title: 'Hold Flight',
        description: `${res.ApiStatus.Message}, Redirecting to Ticket page...`,
      });
      setTimeout(() => {
        navigate(`/flight/ticket/${selectedTransactionRef.current}`);
      }, 2000);
      // handleClosePerformBookingModal();
    } else {
      setAlert({
        variant: 'error',
        title: 'Hold Flight',
        description: res.ApiStatus?.Message,
      });
    }
    setIsLoading(false);
  };

  const handleReleaseTicket = async () => {
    setIsLoading(true);
    const res = await releaseTicketApi(selectedTransactionRef.current);
    if (res && res.ApiStatus?.Status === 'OK') {
      setAlert({
        variant: 'success',
        title: 'Release Flight',
        description: `${res.ApiStatus.Message}, Redirecting to Home page...`,
      });
      setTimeout(() => {
        navigate('/');
      }, 2000);
    } else {
      setAlert({
        variant: 'error',
        title: 'Release Flight',
        description: res.ApiStatus?.Message || 'Failed to release',
      });
    }
    setIsLoading(false);
  };

  const loadPaymentGateways = async () => {
    setIsLoadingPaymentGateways(true);
    setPaymentGatewayError('');
    try {
      const response = await getPaymentGateway(agentId);
      const availableGateways =
        response?.Root?.Result?.AvailablePaymentGateways
          ?.AvailablePaymentGateway;
      let gateways = [];
      if (Array.isArray(availableGateways)) {
        gateways = availableGateways;
      } else if (availableGateways) {
        gateways = [availableGateways];
      }
      const validGateways = gateways.filter(
        (gateway) =>
          typeof gateway?.PaymentMode === 'string' &&
          typeof gateway?.GatewayName === 'string' &&
          gateway.PaymentMode.trim() !== '' &&
          gateway.GatewayName.trim() !== '' &&
          !['cashcard', 'wallet'].includes(gateway.PaymentMode.toLowerCase()),
      );

      if (
        response?.Root?.Status !== 'OK' ||
        response?.Root?.StatusCode !== 200
      ) {
        setPaymentGatewayError(
          'Unable to load payment gateways. Please try again later.',
        );
        setAvailablePaymentGateways([]);
        return;
      }
      setAvailablePaymentGateways(validGateways);
    } catch (error) {
      setPaymentGatewayError(
        'Unable to load payment gateways. Please try again later.',
      );
      setAvailablePaymentGateways([]);
    } finally {
      setIsLoadingPaymentGateways(false);
    }
  };

  const handleSHowConfirmPopup = (transaction) => {
    selectedTransactionRef.current = transaction;
    if (showOtherPaymentMethods) {
      setSelectedPaymentMode('wallet');
      setSelectedPaymentGateway('');
      setPaymentGatewayError('');
    }
    setShowConfirmPopup(true);
    if (showOtherPaymentMethods) {
      loadPaymentGateways();
    }
  };
  const handleShowConfirmReleasePopup = (transaction) => {
    selectedTransactionRef.current = transaction;
    setShowReleasePopup(true);
  };

  const paymentModes = [
    ...paymentModeOptions,
    ...Array.from(
      new Set(
        availablePaymentGateways
          .map((gateway) => gateway.PaymentMode.toLowerCase())
          .filter(
            (mode) =>
              !paymentModeOptions.some((option) => option.mode === mode),
          ),
      ),
    ).map((mode) => ({
      mode,
      label: mode
        .replace(/([a-z])([A-Z])/g, '$1 $2')
        .replace(/^\w/, (letter) => letter.toUpperCase()),
    })),
  ];

  const selectedModeGateways = availablePaymentGateways.filter(
    (gateway) => gateway.PaymentMode.toLowerCase() === selectedPaymentMode,
  );

  useEffect(() => {
    if (isOldFlowMode(selectedPaymentMode)) {
      return;
    }
    const gatewayForMode = availablePaymentGateways.find(
      (gateway) => gateway.PaymentMode.toLowerCase() === selectedPaymentMode,
    );
    setSelectedPaymentGateway(gatewayForMode?.GatewayName || '');
  }, [availablePaymentGateways, selectedPaymentMode]);

  const handlePaymentModeChange = (mode) => {
    setSelectedPaymentMode(mode);
    const gatewayForMode = availablePaymentGateways.find(
      (gateway) => gateway.PaymentMode.toLowerCase() === mode,
    );
    setSelectedPaymentGateway(gatewayForMode?.GatewayName || '');
  };

  return (
    <section className="flight-hold-queues">
      <AppLoading isLoading={isLoading} />
      {alert && (
        <AppAlert
          variant={alert.variant}
          showIcon
          title={alert.title}
          description={alert.description}
        />
      )}
      <section className="flight-hold-queues_container py-3">
        <div className="train-search-container">
          <div className="mb-3 d-flex justify-content-end">
            <div style={{ width: '300px' }}>
              <AppTextInput
                value={searchText}
                label="search"
                onChange={handleSearch}
              />
            </div>
          </div>
        </div>
        {holdQueuesList && holdQueuesList.length === 0 && (
          <div className="my-bookings-page__booking">
            <span className="my-bookings-page__booking_header__trip-info">
              No booking records found.
            </span>
          </div>
        )}
        {holdQueuesList &&
          holdQueuesList.length > 0 &&
          holdQueuesList.map((booking, index) => (
            <div
              key={`${booking.Txid}_${index}`}
              className="flight-hold-queues_card my-2"
            >
              <Row className="spacing-0 p-2 ">
                <Col>
                  <FlightDetail info="Transaction Id:" value={booking.Txid} />
                </Col>
                <Col>
                  <FlightDetail
                    info="Booking Date"
                    value={`${formatDate(
                      getNewDate(booking.BookingDate.split(' ')[0]),
                      DATE_MONTH_YEAR_FORMAT,
                    )} 
                  ${booking?.BookingDate?.split(' ')[1]}`}
                  />
                </Col>
                <Col>
                  <FlightDetail
                    info="Journey Date"
                    value={`${formatDate(
                      getNewDate(booking.JDate),
                      DATE_MONTH_YEAR_FORMAT,
                    )}`}
                  />
                </Col>
                <Col>
                  <FlightDetail
                    info="Sector"
                    value={`${booking.Origin}-${booking.Destination}`}
                  />
                </Col>
                <Col>
                  <FlightDetail info="Carrier" value={booking.Carrier} />
                </Col>
              </Row>
              <Row className="spacing-0 p-2">
                <Col>
                  <FlightDetail
                    info="Pax Name"
                    value={`${booking.PassengerFirstName} ${booking.PassengerLastName}`}
                  />
                </Col>
                <Col>
                  <FlightDetail info="GDSPNR" value={booking.GdsPnr} />
                </Col>
                <Col>
                  <FlightDetail info="AirlinePNR" value={booking.AirlinePnr} />
                </Col>
                <Col>
                  <FlightDetail
                    info="Booking Status"
                    value={booking.BookingStatus}
                  />
                </Col>
                <Col>
                  <FlightDetail info="Time Limit" value={booking.TimeLimit} />
                </Col>
              </Row>
              <div className="spacing-0 row flight-hold-queues_actions">
                <div className="col-4 p-1 d-flex justify-content-center border-767px-bottom">
                  <TicketsIcon style={iconStyle} />
                  <AppLink
                    isLink
                    linkText="Ticket"
                    href={getFlightTicketRoute(booking.Txid)}
                    variant="grey"
                    target="_blank"
                  />
                </div>
                <div className="col-4 p-1 d-flex justify-content-center">
                  <TicketsIcon style={iconStyle} />
                  <AppLink
                    linkText="Perform Ticketing"
                    onClick={() => handleSHowConfirmPopup(booking.Txid)}
                    variant="grey"
                  />
                </div>
                <div className="col-4 p-1 d-flex justify-content-center">
                  <TicketsIcon style={iconStyle} />
                  <AppLink
                    linkText="Release"
                    onClick={() => handleShowConfirmReleasePopup(booking.Txid)}
                    variant="grey"
                  />
                </div>
              </div>
            </div>
          ))}
      </section>
      {showConfirmPopup && (
        <AppModal
          modalTitle="Perform Ticketing"
          onModalClose={handleClosePerformBookingModal}
        >
          <div>
            <p className="fs-14">Are you sure you want to Perform Ticketing?</p>
            {showOtherPaymentMethods && (
              <div className="mb-3">
                <div className="fw-600 fs-14 mb-2">Payment options</div>
                <div className="d-flex flex-wrap justify-content-between gap-2">
                  <AppIconButton
                    onClick={() => handlePaymentModeChange('wallet')}
                    variant="transparent"
                    className={`pg-btn p-0 ${
                      selectedPaymentMode === 'wallet'
                        ? 'red-color'
                        : 'grey-color'
                    }`}
                  >
                    <div>
                      <MdOutlineAccountBalanceWallet />
                      <span>Wallet</span>
                    </div>
                  </AppIconButton>
                  {paymentModes.map(({ mode, label, Icon }) => (
                    <AppIconButton
                      key={mode}
                      onClick={() => handlePaymentModeChange(mode)}
                      variant="transparent"
                      className={`pg-btn p-0 ${
                        selectedPaymentMode === mode
                          ? 'red-color'
                          : 'grey-color'
                      }`}
                    >
                      <div>
                        {Icon ? <Icon /> : null}
                        <span>{label}</span>
                      </div>
                    </AppIconButton>
                  ))}
                </div>
              </div>
            )}
            {showOtherPaymentMethods &&
              !isOldFlowMode(selectedPaymentMode) &&
              selectedModeGateways.length > 0 && (
                <div className="mb-3">
                  <div className="fw-600 fs-14 mb-2">Payment Gateway</div>
                  {isLoadingPaymentGateways && (
                    <p className="fs-12 mb-0">Loading payment gateways...</p>
                  )}
                  {!isLoadingPaymentGateways &&
                    selectedModeGateways.length > 0 && (
                      <div className="d-flex flex-wrap gap-3">
                        {selectedModeGateways.map((gateway, index) => (
                          <AppRadioInput
                            key={`${gateway.GatewayName}_${index}`}
                            id={`hold-queue-${selectedPaymentMode}-${index}`}
                            name="holdQueuePaymentGateway"
                            labelText={gateway.GatewayName}
                            value={gateway.GatewayName}
                            onChange={() =>
                              setSelectedPaymentGateway(gateway.GatewayName)
                            }
                            checked={
                              selectedPaymentGateway === gateway.GatewayName
                            }
                          />
                        ))}
                      </div>
                    )}
                  {/* {!isLoadingPaymentGateways &&
                  selectedModeGateways.length === 0 &&
                  !paymentGatewayError && (
                    <p className="fs-12 mb-0">
                      No gateways are available for this payment mode.
                    </p>
                  )}
                {paymentGatewayError && (
                  <p className="fs-12 text-danger mb-0">
                    {paymentGatewayError}
                  </p>
                )} */}
                </div>
              )}
            <div className="d-flex gap-2 justify-content-center">
              <AppButton
                btnText="No"
                variant="outlined"
                className="flex-1"
                onClick={handleClosePerformBookingModal}
              />
              <AppButton
                btnText="Yes"
                variant="primary"
                className="flex-1"
                onClick={handlePerformTicket}
              />
            </div>
          </div>
        </AppModal>
      )}
      {showReleasePopup && (
        <AppModal
          modalTitle="Release Ticket"
          onModalClose={handleCloseReleasePopup}
        >
          <div>
            <p className="fs-14 text-center">
              Are you sure you want to Release the Ticket?
            </p>
            <div className="d-flex gap-2 justify-content-center">
              <AppButton
                btnText="No"
                variant="outlined"
                className="flex-1"
                onClick={handleCloseReleasePopup}
              />
              <AppButton
                btnText="Yes"
                variant="primary"
                className="flex-1"
                onClick={handleReleaseTicket}
              />
            </div>
          </div>
        </AppModal>
      )}
    </section>
  );
}

export default FlightHoldQueues;
